import { Facebook, GitHub, Instagram, LinkedIn } from "@mui/icons-material";

const Data = {
    name: 'Unique Adhikari',
    title: 'ML Engineer, Backend Developer',
    birthday: '2003/11/11',
    email: 'contactuniqueadhikari@gmail.com',
    address: 'Nepal, Chitwan Madi-09',
    phone: '+977 9866028826',


    socials:{
        LinkedIn:{
            link: 'https://www.linkedin.com/in/uniqueadhikari/',
            text: 'uniqueadhikari',
            icon: <LinkedIn />,
        },
        Facebook:{
            link: 'https://www.facebook.com/uniqueadhikari.007',
            text: 'युनिक अधिकारी',
            icon: <Facebook />
        },
        Instagram:{
            link: 'https://www.instagram.com/unik.adhikarii/',
            text: 'unik.adhikarii',
            icon: <Instagram />
        },
        GitHub:{
            link: 'https://github.com/coffee-and-debugging',
            text: 'coffee-and-debugging',
            icon: <GitHub />,
        },
        
    },


};

export default Data;